module.exports = __webpack_public_path__ + "59d26923f8aeff6e115ea8bd27a76f41.fbx";